import { render, staticRenderFns } from "./SenderList.vue?vue&type=template&id=e1ed5186&"
import script from "./SenderList.vue?vue&type=script&lang=js&"
export * from "./SenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports